define('shared/util/promise/Result',[],function(){
    return function PromiseResult(value) {
        this.result = value;
    };
});
